import { Navigate, Outlet, useLocation } from 'react-router';
import { Loading } from '../../components/ui/Status';
import { useSession } from './session-context';

export function RequireAuth() {
  const { session } = useSession();
  const location = useLocation();

  if (session.status === 'loading') return <Loading label="Opening your library" />;

  if (session.status === 'signedOut') {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  return <Outlet />;
}
